export enum TaskStatusEnum {
  Draft = 'Draft',
  InProgress = 'In Progress',
  Complete = 'Complete',
  Cancelled = 'Cancelled',
}

export const TaskStatus = {
  Draft: {
    value: TaskStatusEnum.Draft,
    description: 'The task have not started yet',
    sort: 0,
    color: '#7f8692',
  },
  InProgress: {
    value: TaskStatusEnum.InProgress,
    description: 'The task has started',
    sort: 1,
    color: '#d9ca3f',
  },
  Complete: {
    value: TaskStatusEnum.Complete,
    description: 'The task is done.',
    sort: 2,
    color: '#53b719',
  },
  Cancelled: {
    value: TaskStatusEnum.Cancelled,
    description: 'The task has been cancelled.',
    sort: 3,
    color: '#030700',
  },
}
